import React, { useState } from 'react';
import { useModal } from '../../context/ModalContext';
import './NMCGuidelines.css';

const guidelines = [
  {
    icon: '⏱️',
    title: 'Duration & Internship',
    body: 'The minimum duration of the MBBS course at foreign institutions must be at least 54 months (4.5 years). A shorter duration of an MBBS course or "fast-track" programs is not recognised by the National Medical Commission for registration in India. The students must complete a 12-month mandatory clinical rotation at the same institution of study.',
  },
  {
    icon: '📚',
    title: 'Curriculum Subjects',
    body: 'Under the FMGL regulations of the NMC in the Gazette of India, Indian students must have studied all the mandatory subjects, as specified in Schedule 1. It covers over 19 core disciplines, including Community Medicine, General Surgery, Paediatrics, Obstetrics & Gynaecology, Dermatology, and others.',
  },
  {
    icon: '🗣️',
    title: 'Medium of Instruction',
    body: 'As per the FMGL regulation 4(iii), the entire medical curriculum must be taught entirely in English, including examinations and clinical training. Any MBBS abroad program that does not teach in English as the medium of instruction or has bilingual teaching would not be recognised by the National Medical Commission.',
  },
  {
    icon: '🏛️',
    title: 'Recognition & Licensing',
    body: 'The foreign institution of the student\'s choice must be recognised by the local jurisdiction of the respective country and have the authority to grant higher education degrees. Indian MBBS graduates must be legally entitled to practise medicine in that respective country.',
  },
  {
    icon: '🏥',
    title: 'Indian Clinical Internship',
    body: 'After completion of the MBBS abroad (academic and clinical phase), the student has to complete a mandatory (additional) internship for 12 months in India (called "Compulsory Rotating Medical Internship"), which will also be an essential component for the NExT.',
  },
  {
    icon: '📝',
    title: 'NEET-UG Qualification',
    body: 'While not explicitly mentioned in the Gazette of India publication, the National Medical Commission (formerly known as the "Medical Council of India") published a public notice in September 2020, clearly stating that the NEET qualification is mandatory for an MBBS abroad.',
  },
  {
    icon: '🩺',
    title: 'Medical Licensing Examination',
    body: 'Indian MBBS graduates must clear the respective medical screening test, as mandated by the National Medical Commission. As mentioned in the Gazette of India, the FMGL regulation 4(ii), the National Exit Test (NExT), or any other mandated test will be required to clear the medical licensing requirement.',
  },
  {
    icon: '📍',
    title: 'Location of the Course',
    body: 'Under "Schedule 1", regulation 2(5), the entire medical education of an Indian medical student must be completed in the same institution without any break period or switching to a different institution. This applies to the mandatory internship requirement.',
  },
  {
    icon: '📅',
    title: '10-Year Completion Rule',
    body: 'Under "Schedule 1" regulation 2(v), the total duration of the MBBS abroad, including the coursework and mandatory clinical rotations, must be completed within ten years from the original date of joining the course at a foreign institution.',
  },
];

const NMCGuidelines = () => {
  const { openModal } = useModal();
  const [expanded, setExpanded] = useState(null);

  return (
    <section className="nmc-section" id="nmc-guidelines">
      <div className="nmc-inner">

        {/* Header */}
        <div className="nmc-hd reveal">
          <div className="sec-label">Regulatory Framework</div>
          <h2 className="sec-title">
            NMC Guidelines for <span className="nmc-grad">MBBS Abroad</span>
          </h2>
          <p className="sec-sub nmc-sub">
            A very important aspect of pursuing an MBBS abroad is considering all the guidelines from India's
            National Medical Commission (NMC). These regulations ensure Indian students' education matches Indian standards.
          </p>
        </div>

        {/* Alert Banner */}
        <div className="nmc-alert reveal">
          <span className="nmc-alert-icon">⚠️</span>
          <div className="nmc-alert-text">
            <strong>Important:</strong> All guidelines are as per the Foreign Medical Graduate Licentiate (FMGL) Regulations, 2021,
            published in the Gazette of India. Non-compliance may result in inability to practice medicine in India.
          </div>
        </div>

        {/* Cards Grid */}
        <div className="nmc-grid reveal">
          {guidelines.map((g, i) => (
            <div
              key={i}
              className={`nmc-card ${expanded === i ? 'nmc-card--open' : ''}`}
              onClick={() => setExpanded(expanded === i ? null : i)}
            >
              <div className="nmc-card-top">
                <div className="nmc-card-icon">{g.icon}</div>
                <div className="nmc-card-title">{g.title}</div>
                <span className="nmc-card-toggle">{expanded === i ? '−' : '+'}</span>
              </div>
              <div className="nmc-card-body">
                <p>{g.body}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="nmc-bottom reveal">
          <div className="nmc-bottom-text">
            <strong>Not sure if your chosen college is NMC-approved?</strong>
            <span> Our counsellors verify every institution before recommending it — completely free.</span>
          </div>
          <button onClick={openModal} className="nmc-bottom-btn">Check Your College →</button>
        </div>

      </div>
    </section>
  );
};

export default NMCGuidelines;